
import React, { useState } from 'react';
import { CForm, CFormInput, CFormLabel, CFormTextarea, CButton } from "@coreui/react";
import axios from "axios";
import "./c.css";

const ClientData = () => {
    const [clientName, setClientName] = useState("");
    const [clientAddress, setClientAddress] = useState("");
    const [noOfHampersPerMasterCarton, setNoOfHampersPerMasterCarton] = useState("");
    const [message, setMessage] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await axios.post("http://localhost:8000/client/add-client", {
                clientName,
                clientAddress,
                noOfHampersPerMasterCarton: Number(noOfHampersPerMasterCarton),
            });

            setMessage("Client added successfully!");

            // Clear form
            setClientName("");
            setClientAddress("");
            setNoOfHampersPerMasterCarton("");

            setTimeout(() => setMessage(""), 3000);

        } catch (err) {
            console.error(err);
            setMessage("Error adding client");
        }
    };

    return (
        <CForm onSubmit={handleSubmit} style={{ maxWidth: "600px"}}>
            <CFormLabel htmlFor="clientName" className='inputA'>Client List Name</CFormLabel>
            <CFormInput
                className='inputC'
                type="text"
                id="clientName"
                placeholder="Enter client name"
                value={clientName}
                onChange={(e) => setClientName(e.target.value)}
            />
            <br />
            <CFormLabel htmlFor="clientAddress" style={{ marginTop: "10px" }}>
                From Address
            </CFormLabel>
            <CFormTextarea
                id="clientAddress"
                className='inputC'
                rows={4}
                placeholder="Enter full address"
                value={clientAddress}
                onChange={(e) => setClientAddress(e.target.value)}
            />
            <br />

            <CFormLabel htmlFor="noOfHampers" style={{ marginTop: "10px" }}>
                Number of Hampers Per Master Carton
            </CFormLabel>
            <CFormInput
                type="number"
                className='inputC'
                id="noOfHampers"
                placeholder="Enter number of hampers"
                value={noOfHampersPerMasterCarton}
                onChange={(e) => setNoOfHampersPerMasterCarton(e.target.value)}
            />

            <CButton type="submit" color="primary" style={{ marginTop: "15px" }}>
                Submit
            </CButton>

            {message && <p style={{ marginTop: "10px", color: "green" }}>{message}</p>}
        </CForm>
    );
}

export default ClientData;
